const actualBtn = document.querySelectorAll('.file-upload')
const fileChosen = document.querySelectorAll('.file-chosen')
const resetBtn = document.querySelectorAll('.reset-upload')

if (typeof (actualBtn) !== 'undefined' && actualBtn !== null) {
  actualBtn.forEach((element, i) => {
    element.setAttribute('hidden', 'hidden')
    element.addEventListener('change', () => {
      fileChosen[i].textContent = element.files[0].name
      resetBtn[i].classList.add('show')
    })
    resetBtn[i].addEventListener('click', () => {
      resetBtn[i].classList.remove('show')
      element.value = ''
      fileChosen[i].textContent = ''
    })
  })
}

function enforceLogoutOnAccessGroupChange () {
  // console.log(document.documentElement.dataset.accessGroup)
  // console.log(document.documentElement.dataset.loginFeGroup)
  if ((document.documentElement.dataset.accessGroup !== document.documentElement.dataset.loginFeGroup) && document.documentElement.dataset.loginFeGroup) {
    document.cookie = 'fe_patient=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    document.cookie = 'fe_hcp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    /* eslint-disable */
    fetch('?logintype=logout').then(() => {
      location.reload()
    })
    /* eslint-enable */
  }
}

window.addEventListener('DOMContentLoaded', enforceLogoutOnAccessGroupChange)
